import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAlertsList, setAlertRead } from 'api/services/alerts';

export const getAlertsListAction = createAsyncThunk('alerts/getAlertsList', () => getAlertsList());
export const setAlertReadAction = createAsyncThunk('alerts/setAlertRead', (id: number) => setAlertRead(id));
